import { useWSMutation } from "@ws-react-query";
import { createInsuranceImport } from "../../../services/api/insurance/import/createInsuranceImport";
import { QUERY_INSURANCE_IMPORT } from "../keys";

export const useMutationCreateInsuranceImport = () =>
  useWSMutation(createInsuranceImport, {
    dependencies: [QUERY_INSURANCE_IMPORT]
  });
